import React from "react";
import market from "../../assets/beforeFooter/market.svg";
import delivery from "../../assets/beforeFooter/delivery.svg";
import returrn from "../../assets/beforeFooter/return.svg";
import card from "../../assets/beforeFooter/card.svg";

function BeforeFooter() {
  return (
    <div className="w-screen py-6 rounded-xl md:py-20 mt-20 bg-blueColor">
      <div className="grid md:p-10 p-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 w-11/12 mx-auto bg-white rounded-xl shadow-md">
        <div className="flex items-start px-4">
          <div className="mr-4">
            <img src={market} alt="market" />
          </div>
          <div className="text-left">
            <h3 className="text-xl text-textBlack font-semibold">
              Endi bozorga borishga hojat yo'q
            </h3>
            <p className="text-base text-gray-500">
              Bizda qulay narxlar va uyga yetkazib berish mavjud
            </p>
          </div>
        </div>

        <div className="flex items-start px-4">
          <div className="mr-4">
            <img src={delivery} alt="delivery" />
          </div>
          <div className="text-left">
            <h3 className="text-xl text-textBlack font-semibold">
              Tez yetkazib berish
            </h3>
            <p className="text-base text-gray-500">
              Bizning xizmatimiz sizni ajablantiradi
            </p>
          </div>
        </div>

        <div className="flex items-start px-4">
          <div className="mr-4">
            <img src={returrn} alt="return" />
          </div>
          <div className="text-left">
            <h3 className="text-xl text-textBlack font-semibold">
              Siz uchun qulayliklar
            </h3>
            <p className="text-base text-gray-500">
              Nosozlik yuzaga kelganda tez rasmiylashtirish va qaytarish
              imkoniyati
            </p>
          </div>
        </div>

        <div className="flex items-start px-4">
          <div className="mr-4">
            <img src={card} alt="market" />
          </div>
          <div className="text-left">
            <h3 className="text-xl text-textBlack font-semibold">
              Bo'lib to'lash
            </h3>
            <p className="text-base text-gray-500">
              6 yoki 12 oy davomida oldindan to'lov
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BeforeFooter;
